export default __webpack_public_path__ + "static/banks-68be11865f6cb6fa01ac2c9c129ad036.jpg";